module.exports = __webpack_public_path__ + "img/title3.c6eb1ad.webp";